// this is an autogenerated file from App/Account/Content/Settings/Content/Leads/Content/Content/Questions/mutation.graphql
import { gql } from 'Data/Api'

export default gql`
mutation app__App_Account_Content_Settings_Content_Leads_Content_Content_Questions($updates: [leads_questions_updates!]!) {
  update_leads_questions_many(updates: $updates) {
    affected_rows
  }
}

`